import { observer } from "mobx-react";
import { CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Alert, Collapse } from "@mui/material";
import styles from './settings.module.scss';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '../../icons/save-icon.png'
import ChangePasswordSchema from "../shared/forms-schemas/change-password-schema";
import { useFormik } from 'formik';
import { useState } from "react";
import PasswordField from "../shared/components/password-field";

const ChangePasswordModal = observer(({ code, show, setShow, uiStore }) => {
    const { error } = uiStore;
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const delay = ms => new Promise(res => setTimeout(res, ms));

    const formik = useFormik({
        initialValues: {
            oldPassword: '',
            password: '',
            confirmPassword: ''
        },
        validationSchema: ChangePasswordSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const result = await uiStore.changePassword(values);
            setLoading(false);
            if (result) {
                setShowSuccess(true);
                await delay(5000);
                uiStore.context.actions.signOut();
            }
        },
    });

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Change Password
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                {error && !showSuccess &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }
                <Collapse in={showSuccess}>
                    <Alert severity="success" sx={{ mb: 2 }}>
                        Successful: Password has been changed. You’ll be logged out now.
                    </Alert>
                </Collapse>

                <Collapse in={!showSuccess}>
                    <Alert severity="info" sx={{ textAlign: 'left', lineHeight: 2 }}>
                        Please note that if you change your password, you will need to log in again. <br />
                    </Alert>
                    <Box
                        component="form"
                        className={styles.formBox}
                        onSubmit={formik.handleSubmit}
                    >
                        <PasswordField
                            required
                            id="oldPassword"
                            label="Current Password"
                            formik={formik}
                        />

                        <PasswordField
                            required
                            id="password"
                            label="New Password"
                            formik={formik}
                            validate
                        />

                        <PasswordField
                            required
                            id="confirmPassword"
                            label="Confirm New Password"
                            formik={formik}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <LoadingButton variant="contained" color="secondary"
                                endIcon={<img src={SaveIcon}
                                    alt='Save icon'
                                    width={24}
                                />}
                                loading={loading}
                                type='submit'
                            >
                                Save
                            </LoadingButton>
                        </Box>
                    </Box>

                </Collapse>

            </DialogContent>
        </Dialog>
    );
});

export default ChangePasswordModal;
